import { SVGProps } from 'react'

function Close(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.75 13.25 13.25.75M.75.75l12.5 12.5"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

Close.defaultProps = { role: 'graphics-document' }

export default Close
